import React from 'react';
import { Link } from 'react-router-dom';
import { DatabaseMessage } from '../../../types/types';
import { getMetaData } from '../../../tool';
import { Card, CardContent, CardHeader } from '../../ui/card';

/**
 * MessageCard component displays a single message with its sender and timestamp.
 * The sender's name is a hyperlink to their user profile.
 *
 * @param message: The message object to display.
 */
const MessageCard = ({ message }: { message: DatabaseMessage }) => (
  <Card className='w-full mb-3 bg-gray-50 border-gray-200'>
    <CardHeader className='py-2 px-4 flex flex-row justify-between items-center border-b border-gray-100'>
      <Link
        to={`/user/${message.msgFrom}`}
        className='font-medium text-sm text-blue-500 hover:underline'>
        {message.msgFrom}
      </Link>
      <div className='text-xs text-gray-500'>{getMetaData(new Date(message.msgDateTime))}</div>
    </CardHeader>
    <CardContent className='p-4 text-sm text-gray-800'>{message.msg}</CardContent>
  </Card>
);

export default MessageCard;
